import { usePathname } from 'next/navigation'

import useDeviceInfo, { DEVICE_TYPES } from '../../../useDeviceInfo'

export default function useMobileCartPage() {
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
  const pathname = usePathname() || ''
  const isCartPage = pathname.endsWith('/cart')

  const isCartPageInMobile = isMobile && isCartPage

  return isCartPageInMobile
}
